import config from 'config.json';

// In SSO-embed mode the three verification lookups (vahan / sarathi / fastag)
// hit the SuperProcure backend "trackboard" endpoints directly instead of
// IFI's own API. These endpoints trigger the VAHAN- / SARATHI- /
// ONETIMEFASTAG- Temporal workflows and are authenticated with the host app's
// SSO token (SP_API attaches it as a Bearer header in embed mode).
//
// The base URL is configured here; swap SP_API_BASE for SP_API_BASE_PROD in
// production builds (mirrors how VAHAN_API / VAHAN_API_PROD are selected).
const spBase = (config.SP_API_BASE || '').replace(/\/+$/, '');

export const spVahanUrl = () => `${spBase}/sp/trackboard/vahanData`;

export const spFastagUrl = () => `${spBase}/sp/trackboard/fastagData`;

export const spSarathiUrl = (licenseNo, dob) =>
  `${spBase}/sp/trackboard/licenceData/${encodeURIComponent(
    licenseNo,
  )}/${encodeURIComponent(dob)}`;
